/**
 * Çerçeve katmanı (Katman 1) — başlık şeridi.
 *
 * Uyaran alanının DIŞI. Buradaki hiçbir şey göreve karışmıyor: şerit
 * sabit yükseklikte, hareketsiz ve zamanlı görevde de aynı
 * (`dokuman/gorsellik.md` §0.2 — animasyon tepki süresini kirletiyor).
 *
 * Çocuğun adı burada YOK, kasıtlı. Plan şeride "egzersiz adı, çocuğun
 * adı, hafta" yazıyordu; kâğıtta ikisi de duruyor çünkü sayfa
 * uygulayıcının elinden çıkıp eve gidiyor ve kime ait olduğu okunmalı.
 * Ekranda ise tablet çocuğun elinde ve bağlantı QR'la gidiyor: adı
 * sunucudan çekmek, üç gün yaşayan bir jetonun arkasına bir kimlik
 * bilgisi daha koymak demek. Karşılığında çocuğa kazandırdığı şey
 * kendi adını okumak.
 */

import { ALAN_ADI, ALAN_IKONU, egzersizAdi, egzersizAlani } from '@nirengi/engine'
import type { AlanKodu } from '@nirengi/engine'
import type { ReactNode } from 'react'

export function AlanIkonu({ alan }: { alan: AlanKodu }) {
  return (
    <svg
      className="alanik"
      viewBox="0 0 24 24"
      role="img"
      aria-label={ALAN_ADI[alan]}
      focusable="false"
      fill="none"
      /* Renk saran öğeden: koyu şeritte açık, açık şeritte koyu */
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {ALAN_IKONU[alan].map((d, i) => (
        <path key={i} d={d} />
      ))}
    </svg>
  )
}

/**
 * Başlık şeridi: alan ikonu, egzersiz adı, ilerleme.
 *
 * İlerleme SAYI — "3 / 8". Çubuk değil: çubuk dolarken geriye kalan
 * işi değil kalan süreyi anlatıyor gibi duruyor, çocuk hızlanıyor;
 * hız da ölçtüğümüz şeylerden biri olduğu için bu bedava bir süsleme
 * değil, veriyi kaydıran bir süsleme.
 *
 * `sag` yalnızca gösterim kipi için: seviye düğmeleri çerçevenin değil
 * deneme düzeneğinin parçası, bağlı modda hiç görünmüyor.
 */
export function Serit({
  kod,
  sira,
  toplam,
  sag,
}: {
  kod: string
  sira?: number
  toplam?: number
  sag?: ReactNode
}) {
  const alan = egzersizAlani(kod)
  return (
    <header className="serit">
      <span className="ikon" title={ALAN_ADI[alan]}>
        <AlanIkonu alan={alan} />
      </span>
      <span className="ad">{egzersizAdi(kod)}</span>
      {sag ?? (sira && toplam ? <span className="ilerleme">{sira} / {toplam}</span> : null)}
    </header>
  )
}
